import { useEffect, useState } from 'react';

// material
import { Container } from '@mui/material';
// redux
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import { useLazyQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Booking } from '../../../@type/booking';
import { BOOKING } from '../../../_apis_/queries/booking';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import LoadingComponent from '../../../components/LoadingComponent';
import Page from '../../../components/Page';
import { fDateString } from '../../../utils/formatTime';
import BookingDetailForm from './components/BookingDetailForm';

// ----------------------------------------------------------------------

export default function BookingDetail(): JSX.Element {
  const { themeStretch } = useSettings();
  const { t } = useTranslation();
  const params = useParams<{ id: string }>();
  const today = new Date();
  const [currentBooking, setCurrentBooking] = useState<Booking>();
  const [isLoading, setIsLoading] = useState(true);
  const dateBooking = localStorage.getItem('dateBooking') || fDateString(today);

  useEffect(() => {
    const variables = {
      dateString: dateBooking,
      bookingId: params?.id
    };
    ordersQuery({ variables });
  }, []);

  const [ordersQuery] = useLazyQuery(BOOKING, {
    onCompleted(response: { booking?: Booking }) {
      if (response.booking) setCurrentBooking(response.booking);
      setIsLoading(false);
    },
    fetchPolicy: 'no-cache'
  });

  return (
    <Page title={t('Booking Detail')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={t('Booking Detail')}
          links={[
            { name: t('Dash Board'), href: PATH_DASHBOARD.root },
            { name: t('Booking'), href: PATH_DASHBOARD.booking.list() },
            { name: currentBooking?.id || '' }
          ]}
        />
        {isLoading || !currentBooking ? <LoadingComponent /> : <BookingDetailForm currentBooking={currentBooking} />}
      </Container>
    </Page>
  );
}
